
<PopOver
	:overlay="false"
	:open="open"
	:placement="placement"
	class="flow-info-popover"
	@click.native="handleClick"
	@mouseover.native="open = true"
	@mouseleave.native="open = false"
>
	<!-- @slot Used for element on which popover will display -->
	<slot />

	<template #content>
		<div class="info-pop-over-template" :style="{ maxWidth: maxWidth }">
			<div v-if="$slots['header']" class="header">
				<!-- @slot Used to display header with close icon -->
				<slot name="header" />
			</div>

			<div class="body">
				<Container direction="column" :padding="0" :gap="8">
					<!-- @slot Used to display context specific information -->
					<slot name="body" />
				</Container>
			</div>
		</div>
	</template>
</PopOver>
